export default "__VITE_ASSET__BJDABzzO__"